import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { CPanel, H2, H4, Caption, Flex } from '@appcues/component-library';
import { Icon } from 'next/components/ui';
import MauMeter from 'components/Subscription/CurrentPeriod/MauMeter';
import UrlRollup from 'components/Subscription/CurrentPeriod/UrlRollup';
import Pill from 'components/Common/Pill';
import { fetchUrlRollup } from 'actions/billing';
import { selectAccountUrlRollup } from 'reducers/billing';
import { numberWithCommas } from 'utils/textFormatting';

class CurrentPeriod extends Component {
  state = {
    moreInfo: false,
  };

  componentDidMount() {
    const { accountId, fetchUrlRollup: request, uuid, urlRollup } = this.props;

    if (urlRollup.length === 0) {
      request(accountId, uuid);
    }
  }

  render() {
    const { anonymousMaus, monthlyActiveUsers, planLimit, urlRollup } =
      this.props;
    const { moreInfo } = this.state;

    const meterDisplayColors = {
      compliant: '$blue',
      warning: '$yellow',
      over: '$red',
    };

    const overFivePercentUrls = urlRollup.filter(
      url => Number.parseInt(url.total_percent, 10) > 5
    );

    const overallAnonymousPercent = Math.round(
      (anonymousMaus / monthlyActiveUsers) * 100,
      2
    );

    const formattedPlanLimit = numberWithCommas(planLimit);
    const formattedOverallUsers = numberWithCommas(monthlyActiveUsers);

    const completePercent =
      monthlyActiveUsers && planLimit
        ? (monthlyActiveUsers / planLimit) * 100
        : 0;

    const determineStatus = percent => {
      if (percent > 85 && completePercent <= 100) {
        return 'warning';
      }
      if (completePercent > 100) {
        return 'over';
      }
      return 'compliant';
    };

    const currentStatus = determineStatus(completePercent);
    const showWarning = currentStatus !== 'compliant' && planLimit;

    const possibleInstallIssue =
      overFivePercentUrls.length > 0 || overallAnonymousPercent > 0;

    const renderWarning = status => {
      return <Pill fillColor={meterDisplayColors[status]} />;
    };

    return (
      <CPanel
        renderHeaderContent={() => showWarning && renderWarning(currentStatus)}
      >
        <CPanel.Header>
          <Flex alignItems="baseline" marginBottom={12}>
            <H4 type="secondary">MAU Count</H4>
            <Caption type="tertiary">&nbsp; last 30 days</Caption>
          </Flex>
        </CPanel.Header>
        <Flex alignItems="baseline" marginBottom={12}>
          <H2 type="secondary">{`${formattedOverallUsers} of ${formattedPlanLimit}`}</H2>{' '}
          <Caption type="tertiary">&nbsp; monthly active users (MAUs)</Caption>
        </Flex>
        <MauMeter
          completePercent={completePercent}
          currentStatus={currentStatus}
          fillColor={meterDisplayColors[currentStatus]}
          showWarning={showWarning}
        />
        {possibleInstallIssue && (
          <MoreInfoWrapper
            onClick={() => this.setState({ moreInfo: !moreInfo })}
          >
            <H4 type="secondary" width={975}>
              MAU Troubleshooting
            </H4>
            <Icon icon={`chevron-${moreInfo ? 'down' : 'up'}`} />
          </MoreInfoWrapper>
        )}
        {moreInfo && (
          <UrlRollup
            anonymousMaus={anonymousMaus}
            monthlyActiveUsers={monthlyActiveUsers}
            overFivePercentUrls={overFivePercentUrls}
          />
        )}
      </CPanel>
    );
  }
}

CurrentPeriod.defaultProps = {
  planLimit: 1000000,
};

const mapStateToProps = state => {
  return {
    urlRollup: selectAccountUrlRollup(state),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchUrlRollup: (accountId, uuid) => {
      dispatch(fetchUrlRollup(accountId, uuid));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CurrentPeriod);

const MoreInfoWrapper = styled.div`
  margin-top: 1rem;
  display: flex;
  width: 100%;
  padding: 8px;
  border-bottom: 1px solid ${props => props.theme['$gray-3']};

  &:hover {
    cursor: pointer;
    background: ${props => props.theme['$gray-2']}
`;
